<!-- Mobile menu -->
<div class="mobile-nav-links-wrapper menu">
    <a id="mobile-menu-close"></a>
    <ul class="mobile-nav-links">
        <li id="mobile-nav-link-dashboard" [ngClass]="getDashboardClasses()"><a [routerLink]="'/'">Dashboard</a></li>
        <li id="mobile-nav-link-contact" [ngClass]="getContactClasses()"><a [routerLink]="'/contact'">Contact</a></li>
        <li id="mobile-nav-link-login" [ngClass]="getLoginClasses()" [hidden]="!isLoginVisible()"><a [routerLink]="'/login'">Login</a></li>
        <li id="mobile-nav-link-logout" [ngClass]="getLogoutClasses()" [hidden]="!isLogoutVisible()"><a [routerLink]="'/logout'">Logout</a></li>
    </ul>
</div>

<!-- Intercoll version -->
<div [hidden]="isCollexusVersion()">
    <div class="container">
        <header class="desktop">
            <div class="nav-wrapper">
                <a class="logo-anchor" [href]="getLogoLink()">
                    <div class="logo">
                        <h2>DebtManagers</h2>
                    </div>
                </a>
                <div class="nav-links-wrapper">
                    <ul class="nav-links">
                        <li [ngClass]="getDashboardClasses()"><a [routerLink]="'/'">Dashboard</a></li>
                        <li [ngClass]="getContactClasses()"><a [routerLink]="'/contact'">Contact</a></li>
                        <li [ngClass]="getLoginClasses()" *ngIf="isLoginVisible()"><a [routerLink]="'/login'">Login</a></li>
                        <li [ngClass]="getLogoutClasses()" *ngIf="isLogoutVisible()">
                            <a [routerLink]="'/logout'">Logout</a>
                        </li>
                    </ul>
                    <a href="" class="login-icon"><img src="assets/profile-icon.svg"></a>
                </div>
            </div>
        </header>
        <header class="mobile">
            <div class="nav-wrapper">
                <a class="logo-anchor" [href]="getLogoLink()">
                    <div class="logo">
                        <h2>DebtManagers</h2>
                    </div>
                </a>
                <a id="mobile-menu"></a>
            </div>
        </header>
    </div>
</div>
<!---->

<!-- Collexus Version -->
<div [hidden]="!isCollexusVersion()">
    <header class="desktop">
        <div class="d-flex flex-wrap collexus-desktop-nav-container">
            <div class="col-4 collexus-desktop-logo-wrapper">
                <img class="logo-image" [src]="getLogoUrl()" /> 
            </div>

            <div class="col-8 collexus-desktop-nav-wrapper">
                <h2>{{getTitle()}}</h2>
                <div class="nav-links-wrapper">
                    <ul class="nav-links">
                        <li [ngClass]="getDashboardClasses()"><a [routerLink]="'/'">Dashboard</a></li>
                        <li [ngClass]="getContactClasses()"><a [routerLink]="'/contact'">Contact</a></li>
                        <li [ngClass]="getLoginClasses()" *ngIf="isLoginVisible()"><a [routerLink]="'/login'">Login</a></li>
                        <li [ngClass]="getLogoutClasses()" *ngIf="isLogoutVisible()">
                            <a [routerLink]="'/logout'">Logout<span class="k-icon k-i-logout logout-icon"></span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
    
    <div class="container">
        <header class="mobile">
            <div class="nav-wrapper">
                <img class="logo-image" [src]="getLogoUrl()" /> 
                <h2>{{getTitle()}}</h2>
                <a id="collexus-mobile-menu"></a>
            </div>
        </header>
    </div>
</div>
<!---->
